// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Header.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reuse shared styles from the old header: subscription badge, date-gen pill,
   and the donation modal classes (.modal-overlay/.modal-content/.modal-close)
   still rendered by App.js. */

.app-topbar {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  padding: var(--space-sm) var(--space-lg);
  background: var(--glass-bg-strong);
  border-bottom: 1px solid var(--glass-border);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  min-width: 0;
}

.topbar-menu-btn {
  display: none;
  position: relative;
  /* Keep the toggle above the right-hand group so it stays tappable even if a
     very narrow screen lets the content overlap. */
  z-index: 1;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  background: var(--glass-bg);
  color: var(--color-white);
  font-size: 1.1rem;
  cursor: pointer;
}

.topbar-welcome {
  font-size: var(--font-size-sm);
  color: var(--color-white);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topbar-welcome strong {
  color: var(--color-accent-light);
  font-weight: var(--font-weight-bold);
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  flex-shrink: 0;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

/* Tablet/mobile: show the menu button, collapse the action labels to icons */
@media (max-width: 768px) {
  .topbar-menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* Drop space-between here: when the two flex children together exceed the
     viewport, space-between's "unsafe" overflow keeps the right group pinned to
     the right edge, so it slides left OVER the menu button and makes it
     untappable. With flex-start + margin-left:auto the layout looks identical
     while it fits, but on overflow the auto margin collapses to 0 and the group
     packs from the left — spilling off the RIGHT edge instead of covering the
     button, which stays fully tappable. */
  .app-topbar {
    justify-content: flex-start;
    gap: var(--space-sm);
    padding: var(--space-sm) var(--space-md);
  }

  .topbar-welcome {
    max-width: 40vw;
  }

  .topbar-right {
    margin-left: auto;
    gap: var(--space-xs);
  }

  /* Compact the date-gen pill on mobile to reclaim horizontal space. */
  .header-date-gens {
    padding: 3px 8px;
    font-size: 0.78rem;
  }

  /* Keep the bar from overflowing: collapse the action buttons to icons only.
     ui/Button keeps its left icon; each button carries an aria-label so the
     hidden text remains available to assistive tech. */
  .topbar-actions {
    gap: var(--space-xs);
  }

  .topbar-actions .btn-content {
    display: none;
  }

  .topbar-actions .btn-icon-left {
    margin: 0;
  }
}

@media (max-width: 560px) {
  .topbar-welcome {
    display: none;
  }
}

/* On the narrowest phones the right-hand group is all interactive (appearance
   picker + Shop/Suggestions/Profile/Logout — none of which live in the sidebar
   drawer, so they must stay reachable). The date-gen pill is the only purely
   informational item, so drop it here to keep everything else on-screen. */
@media (max-width: 480px) {
  .header-date-gens {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/TopBar.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAG9B;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,kCAAkC;EAClC,4CAA4C;EAC5C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB;mDACiD;EACjD,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;;;;;0CAMwC;EACxC;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,qEAAqE;EACrE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;uDAEqD;EACrD;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;2EAG2E;AAC3E;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Reuse shared styles from the old header: subscription badge, date-gen pill,\n   and the donation modal classes (.modal-overlay/.modal-content/.modal-close)\n   still rendered by App.js. */\n@import './Header.css';\n\n.app-topbar {\n  position: sticky;\n  top: 0;\n  z-index: var(--z-sticky);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-md);\n  padding: var(--space-sm) var(--space-lg);\n  background: var(--glass-bg-strong);\n  border-bottom: 1px solid var(--glass-border);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n}\n\n.topbar-left {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  min-width: 0;\n}\n\n.topbar-menu-btn {\n  display: none;\n  position: relative;\n  /* Keep the toggle above the right-hand group so it stays tappable even if a\n     very narrow screen lets the content overlap. */\n  z-index: 1;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  background: var(--glass-bg);\n  color: var(--color-white);\n  font-size: 1.1rem;\n  cursor: pointer;\n}\n\n.topbar-welcome {\n  font-size: var(--font-size-sm);\n  color: var(--color-white);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.topbar-welcome strong {\n  color: var(--color-accent-light);\n  font-weight: var(--font-weight-bold);\n}\n\n.topbar-right {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  flex-shrink: 0;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n/* Tablet/mobile: show the menu button, collapse the action labels to icons */\n@media (max-width: 768px) {\n  .topbar-menu-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Drop space-between here: when the two flex children together exceed the\n     viewport, space-between's \"unsafe\" overflow keeps the right group pinned to\n     the right edge, so it slides left OVER the menu button and makes it\n     untappable. With flex-start + margin-left:auto the layout looks identical\n     while it fits, but on overflow the auto margin collapses to 0 and the group\n     packs from the left — spilling off the RIGHT edge instead of covering the\n     button, which stays fully tappable. */\n  .app-topbar {\n    justify-content: flex-start;\n    gap: var(--space-sm);\n    padding: var(--space-sm) var(--space-md);\n  }\n\n  .topbar-welcome {\n    max-width: 40vw;\n  }\n\n  .topbar-right {\n    margin-left: auto;\n    gap: var(--space-xs);\n  }\n\n  /* Compact the date-gen pill on mobile to reclaim horizontal space. */\n  .header-date-gens {\n    padding: 3px 8px;\n    font-size: 0.78rem;\n  }\n\n  /* Keep the bar from overflowing: collapse the action buttons to icons only.\n     ui/Button keeps its left icon; each button carries an aria-label so the\n     hidden text remains available to assistive tech. */\n  .topbar-actions {\n    gap: var(--space-xs);\n  }\n\n  .topbar-actions .btn-content {\n    display: none;\n  }\n\n  .topbar-actions .btn-icon-left {\n    margin: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .topbar-welcome {\n    display: none;\n  }\n}\n\n/* On the narrowest phones the right-hand group is all interactive (appearance\n   picker + Shop/Suggestions/Profile/Logout — none of which live in the sidebar\n   drawer, so they must stay reachable). The date-gen pill is the only purely\n   informational item, so drop it here to keep everything else on-screen. */\n@media (max-width: 480px) {\n  .header-date-gens {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
